import { paginatedGroupsSchema, trainingGroupSchema } from "../../schemas/training";
import { fetchApi, fetchVoid } from "../internal";

export const groups = {
	create: (clubId: string, seasonId: string, data: unknown) =>
		fetchApi(`/clubs/${clubId}/training/groups`, trainingGroupSchema, {
			body: JSON.stringify({ season_id: seasonId, ...(data as object) }),
			method: "POST",
		}),
	delete: (clubId: string, groupId: string) =>
		fetchVoid(`/clubs/${clubId}/training/groups/${groupId}`, {
			method: "DELETE",
		}),
	get: (clubId: string, groupId: string) =>
		fetchApi(`/clubs/${clubId}/training/groups/${groupId}`, trainingGroupSchema),
	list: (clubId: string, seasonId?: string) => {
		const searchParams = new URLSearchParams();
		if (seasonId) searchParams.set("season_id", seasonId);
		const qs = searchParams.toString();
		return fetchApi(`/clubs/${clubId}/training/groups${qs ? `?${qs}` : ""}`, paginatedGroupsSchema);
	},
	update: (clubId: string, groupId: string, data: unknown) =>
		fetchApi(`/clubs/${clubId}/training/groups/${groupId}`, trainingGroupSchema, {
			body: JSON.stringify(data),
			method: "PUT",
		}),
};
